import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
    spacing: 6,
    typography: {
        fontSize: 13,
        h6: {
            fontWeight: 400
        }
    },
    palette: {
        primary: {
            main: "#002f55"
        },
        secondary: {
            main: "#4782da"
        },
        error: {
            main: "#e53935"
        }
    },
    overrides: {
        MuiTab: {
            root: {
                lineHeight: "1.5"
            }
        },
        MuiTableCell: {
            sizeSmall: {
                padding: "4px 8px",
                "& .MuiAvatar-root": {
                    width: "30px",
                    height: "30px"
                }
            }
        },
        MuiInputBase: {
            root: {
                fontSize: "13px"
            },
            input: {
                paddingTop: "3px"
            }
        },
        MuiDialogTitle: {
            root: {
                textTransform: "uppercase"
            }
        },
        MuiAvatar: {
            root: {
                backgroundColor: "#fff"
            }
        }
    }
});

export default theme;



// WEBPACK FOOTER //
// ./src/inar2/theme.ts